import { mapGetters, mapMutations } from "vuex";
import indexBasedTopicLoader from "@/mixins/indexBasedTopicLoader";
import topicScenarioEditor from "@/mixins/topicScenarioEditor";

export default {
  name: "CoachingRenderless",

  mixins: [indexBasedTopicLoader, topicScenarioEditor],

  data() {
    return {
      isFreeModeActive: false,
      freeModeInitialFen: "",
      isPreviewModalActive: false,
      isCustomFenModalActive: false,
      isQuizModeActive: false,
      quizScenarios: [],
      isTopicSelectorActive: false,
      savedScenarioState: null, // Add this to store the state
    };
  },

  computed: {
    ...mapGetters([
      "getCurrentScenario",
      "getCurrentTopicId",
      "isCustomScenario",
      "getShowMoveTable",
      "getScenarioState",
    ]),

    scenario() {
      return this.getCurrentScenario || null;
    },

    isQuizAvailable() {
      return this.scenarios.filter((s) => s.isPuzzle).length >= 10;
    },
  },

  watch: {
    getCurrentTopicId: {
      async handler(newId) {
        if (newId !== null) {
          const index = this.topics.findIndex((t) => t.id === newId);
          if (index !== -1) {
            this.topicIndex = index;
          }
        }
      },
      immediate: true,
    },

    selectedScenario: {
      handler(newScenario) {
        if (newScenario) {
          this.setCurrentScenario(newScenario);
          this.isPreviewModalActive = false;
          this.isTopicSelectorActive = false;
          this.exitFreeMode();
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapMutations([
      "setCurrentScenario",
      "setShowMoveTable",
      "setScenarioState",
    ]),

    toggleMovesTable() {
      this.setShowMoveTable(!this.getShowMoveTable);
    },

    enterFreeMode(fen) {
      // Save current scenario state before entering free mode
      if (!this.isCustomScenario && this.selectedScenario) {
        this.savedScenarioState = {
          scenarioId: this.selectedScenario.id,
          state: this.getScenarioState,
        };
      }

      this.freeModeInitialFen = fen;
      this.isFreeModeActive = true;
    },

    exitFreeMode() {
      if (this.isFreeModeActive === false) return;

      this.isFreeModeActive = false;
      this.freeModeInitialFen = "";
    },

    reloadSavedScenario() {
      if (!this.savedScenarioState) return;

      if (this.savedScenarioState.scenarioId !== this.selectedScenario.id) {
        this.handleSelectScenario(this.savedScenarioState.scenarioId);
      } else {
        this.setCurrentScenario(this.selectedScenario);
      }

      process.nextTick(() => {
        this.$store.commit("setScenarioState", this.savedScenarioState.state);
        this.savedScenarioState = null;
      });
    },

    loadScenarioFromPgn(pgn) {
      this.setCurrentScenario({
        topic: {
          id: null,
          title: "Custom Example",
        },
        pgn: pgn,
        title: "From PGN",
        isPuzzle: pgn.includes("{[#]}"),
      });

      this.$buefy.toast.open({
        message: "Custom PGN loaded successfully!",
        type: "is-success",
      });
    },

    loadScenarioFromFen(fen) {
      this.exitFreeMode();
      this.setCurrentScenario({
        topic: {
          id: null,
          title: "Custom Example",
        },
        pgn: `[Event "From FEN"]\n[FEN "${fen}"]\n*`,
        title: "From FEN",
        isPuzzle: false,
      });

      this.$buefy.toast.open({
        message: "Custom FEN loaded successfully!",
        type: "is-success",
      });
    },

    startQuiz() {
      const selectedScenarios = this.scenarios
        .filter((s) => s.isPuzzle)
        .sort(() => Math.random() - 0.5)
        .slice(0, 10);

      if (selectedScenarios.length === 0) {
        this.$buefy.toast.open({
          message: "No puzzles found for this topic",
          type: "is-warning",
        });
        return;
      }

      this.handleQuizCreated(selectedScenarios);
    },

    handleQuizCreated(scenarios) {
      this.quizScenarios = scenarios;
      this.isQuizModeActive = true;
    },

    exitQuiz() {
      this.isQuizModeActive = false;
      this.quizScenarios = [];
    },

    openTopicSelector() {
      this.isTopicSelectorActive = true;
    },
  },
};
